// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Jm34","notes":"Notes_notes__iKoue","note":"Notes_note__2EKUY","markdown":"Notes_markdown__1HCtv"};